import { Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface ChangesBarProps {
  toFollowCount: number
  toUnfollowCount: number
  saving: boolean
  onSave: () => void
  onDiscard: () => void
}

export function ChangesBar({ toFollowCount, toUnfollowCount, saving, onSave, onDiscard }: ChangesBarProps) {
  const dirty = toFollowCount + toUnfollowCount > 0
  if (!dirty) return null

  return (
    <div className="sticky bottom-4 z-30 mx-auto mt-6 w-full max-w-3xl">
      <div className="flex items-center justify-between gap-3 rounded-full border bg-card px-4 py-2.5 shadow-lg">
        <div className="flex items-center gap-3 text-sm">
          {toFollowCount > 0 && (
            <span className="inline-flex items-center gap-1">
              <span className="font-semibold text-emerald-600">+{toFollowCount}</span>
              <span className="text-muted-foreground">to follow</span>
            </span>
          )}
          {toFollowCount > 0 && toUnfollowCount > 0 && (
            <span className="text-muted-foreground/40">·</span>
          )}
          {toUnfollowCount > 0 && (
            <span className="inline-flex items-center gap-1">
              <span className="font-semibold text-destructive">−{toUnfollowCount}</span>
              <span className="text-muted-foreground">to unfollow</span>
            </span>
          )}
        </div>
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="sm" onClick={onDiscard} disabled={saving}>
            Discard
          </Button>
          <Button size="sm" onClick={onSave} disabled={saving} className="gap-1.5">
            {saving && <Loader2 className="h-3.5 w-3.5 animate-spin" />}
            Save changes
          </Button>
        </div>
      </div>
    </div>
  )
}
